import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { originalEmailActions } from '../actions/originalEmail';
import * as originalEmailApi from '../api/originalEmail';

const {
  originalEmailGet,
  originalEmailGetSucceeded,
  originalEmailGetFailed,
  originalEmailHtmlGetByType,
  originalEmailHtmlGetByTypeSucceeded,
  originalEmailHtmlGetByTypeFailed,
  originalEmailGetHtmlMessage,
  originalEmailGetHtmlMessageSucceeded,
  originalEmailGetHtmlMessageFailed,
  originalEmailGetPrinterFriendly,
  originalEmailGetPrinterFriendlySucceeded,
  originalEmailGetPrinterFriendlyFailed,
} = originalEmailActions;

// Saga
export const originalEmail = [
  takeLatest(
    originalEmailGet.toString() as any,
    genWithPromiseWithRequestUrl(
      originalEmailApi.originalEmailGet,
      originalEmailGetSucceeded,
      originalEmailGetFailed,
    ),
  ),

  takeEvery(
    originalEmailGetHtmlMessage.toString() as any,
    genWithPromiseHtmlEmailMessage(
      originalEmailApi.originalEmailGet,
      originalEmailGetHtmlMessageSucceeded,
      originalEmailGetHtmlMessageFailed,
    ),
  ),

  takeLatest(
    originalEmailGetPrinterFriendly.toString() as any,
    genWithPromiseWithRequestUrl(
      originalEmailApi.originalEmailGet,
      originalEmailGetPrinterFriendlySucceeded,
      originalEmailGetPrinterFriendlyFailed,
    ),
  ),

  takeEvery(
    originalEmailHtmlGetByType.toString() as any,
    genWithPromise(
      originalEmailApi.originalEmailGetByType,
      originalEmailHtmlGetByTypeSucceeded,
      originalEmailHtmlGetByTypeFailed,
    ),
  ),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}

function genWithPromiseWithRequestUrl(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      result.requestURL = action.payload.url;
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}

function genWithPromiseHtmlEmailMessage(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      const urlArray = action.payload.url.split('/');

      result.messageId = urlArray.pop();
      result.requestURL = action.payload.url;
      result.csid = action.payload.csid;

      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
